import { render, staticRenderFns } from "./SumberDanaChart.vue?vue&type=template&id=ebd1e7ec&"
import script from "./SumberDanaChart.vue?vue&type=script&lang=js&"
export * from "./SumberDanaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports